import AllServices from './allServices';
import React from 'react'

const ServicesPage: React.FC = () => {


    return (
        <>
            <AllServices/>
        </>
    )
}

export default ServicesPage